import React from 'react'
import {Col, Row} from 'react-bootstrap'
import Carousel from 'react-multi-carousel'
import {KTSVG} from '../../../../_metronic/helpers'
import TopDevelopers from './TopDevelopers'

type Props = {}

const TopDeveloperList = (props: Props) => {
  return (
    <div className='d-flex flex-column container mt-6 mt-lg-10  mb-20 '>
      <Row>
        <Col xl={8} md={6}>
          <div>
            <span className='fw-bolder fs-1'>Our top-rated Developers</span>
          </div>
          <div>
            <p className='fw-600 fs-5'>
              Take a look at our top picked <br />
              Developers
            </p>
          </div>

          <Carousel
            additionalTransfrom={0}
            infinite={false}
            autoPlay={false}
            centerMode={false}
            className=''
            
            dotListClass=''
            draggable
            focusOnSelect={false}
            itemClass=''
            keyBoardControl
            minimumTouchDrag={80}
            renderButtonGroupOutside={true}
            responsive={{
              desktop: {
                breakpoint: {
                  max: 3000,
                  min: 1024,
                },
                items: 3,
                partialVisibilityGutter: 40,
              },
              mobile: {
                breakpoint: {
                  max: 464,
                  min: 0,
                },
                items: 1,
                partialVisibilityGutter: 30,
              },
              tablet: {
                breakpoint: {
                  max: 1024,
                  min: 464,
                },
                items: 1,
                partialVisibilityGutter: 30,
              },
            }}
            sliderClass=''
            partialVisible={false}
            showDots={false}
            slidesToSlide={1}
            swipeable
          >
            <TopDevelopers />
            <TopDevelopers />
            <TopDevelopers />
            <TopDevelopers />
            <TopDevelopers />
          </Carousel>
        </Col>
        <Col xl={4} md={6} className='mt-10'>
          <div className='card-body p-0 d-flex mt-5 '>
            <div className='d-flex align-items-start justify-content-start flex-grow-1 bg-light-warning p-8 card-rounded flex-grow-1 position-relative'>
              <div className='d-flex flex-column align-items-start flex-grow-1 h-100'>
                <div className='p-1 flex-grow-1'>
                  <h4 className='text-warning font-weight-bolder'>Join Lucian as a developer</h4>
                  <p className='text-dark-50 font-weight-bold mt-3'>
                    Create your developer account <br />
                    and start working remotely from
                    <br /> the comfort of your home
                  </p>

                  <button className=' btn btn-link bg-transparent text-warning fw-bold'>
                    Become a lucian developer
                    <span className='svg-icon svg-icon-2 svg-icon-warning'>
                      <KTSVG
                        path='/media/icons/duotune/arrows/arr071.svg'
                        className='svg-icon-1 svg-icon-warning'
                      />
                    </span>
                  </button>
                </div>
                <div className=' d-flex position-absolute  bottom-0  overflow-hidden pull-right align-self-end   '>
                  <img
                    src='/media/svg/humans/custom-13.svg'
                    className='max-h-200px max-h-xl-275px mb-n20 m-0 p-0 pull-right align-self-end '
                    alt=''
                  />
                </div>
              </div>
            </div>
          </div>

          <div className='card-body p-0 d-flex mt-10'>
            <div className='d-flex align-items-start justify-content-start flex-grow-1 bg-light-primary p-8 card-rounded flex-grow-1 position-relative'>
              <div className='d-flex flex-column align-items-start flex-grow-1 h-100'>
                <div className='p-1 flex-grow-1'>
                  <h4 className='text-primary font-weight-bolder'>
                    Want to hire developers for your project?
                  </h4>
                  <p className='text-dark-50 font-weight-bold mt-3'>
                    Get one of our tallented developers on it in no time
                  </p>

                  <button className=' btn    btn-primary btn-sm  fw-bold'>Contact us</button>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default TopDeveloperList
